
import UserInfo from "../session/UserInfo";
import { makeCachedGet } from "../util/requestHelpers";
import { TargetingProvider, Targeting } from "../interfaces/TargetingProvider";
import WatchlistClient from "./WatchlistClient";

export interface WatchlistClientOptions {
  watchlistServiceUrl: string;
  userInfo : UserInfo
}

export interface UserWatchlistsParams {
  bconnectId: string;
}

const storageKey = "bbads_watchlist";
const DEFAULT_WATCHLIST_TARGET = { watchlist: "no" };

export class WatchlistProvider implements TargetingProvider {

  private get: ReturnType<typeof makeCachedGet<Targeting>>;
  private _userInfo: UserInfo;
  private timeoutInMs = 5000;
  private watchlistClient: WatchlistClient;

  constructor(userInfo: UserInfo) {
      this._userInfo = userInfo;
      this.get = makeCachedGet<Targeting>("watchlistGet", <T>(userId: string) => this.getUserWatchlists(userId) as Promise<T>);
      this.watchlistClient = new WatchlistClient({
          watchlistServiceUrl: `${ process.env.REGISTRATION_URL || "https://login.bloomberg.com" }/watchlist-service`
      });
  }

  async getUserWatchlists(userId:string): Promise<Targeting> {

      try {
          const watchlists = await this.watchlistClient.getUserWatchlists({ bconnectId: userId });

          if (watchlists?.data) {
              return { watchlist: "yes" };
          }
      } catch (error) {
          console.error(`Error get watchlist: ${ error }`, error);
      }

      return DEFAULT_WATCHLIST_TARGET;
  }

  private async getTargetingInner(): Promise<Targeting> {
      const userInfo = await this._userInfo.getUserInfo();
      const userId = userInfo?.userId;

      return userId ? this.get(userId, this.timeoutInMs, {}, storageKey) : DEFAULT_WATCHLIST_TARGET;
  }

  getTargeting(): Promise<Targeting> {
      return this.getTargetingInner().catch((error) => {
          console.error(`Error fetching watchlist targeting: ${ error }`, error);

          return DEFAULT_WATCHLIST_TARGET;
      });
  }

}
